<template>
  <div class="control">
    <el-container>
      <el-menu
        :default-active="paths"
        :router="false"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        :collapse="!isCollapse"
        background-color="#0092D9"
        text-color="#ffffff"
        active-text-color="#EC8E00"
      >
        <el-menu-item @click="isCollapse = !isCollapse">
          <i class="el-icon-menu"></i>
          <span slot="title">{{
            $store.state.shortName == null
              ? "上海益埃毕"
              : $store.state.shortName
          }}</span>
        </el-menu-item>
 
        <el-submenu
          :index="(item.fctm01 || item.path || item.authName) + ''"
          v-for="item in menuData"
          :key="item.id"
        >
          <template slot="title">
            <!-- <i :class="item.icon"></i> -->
            <img
              :src="`img/6.0/PC/${item.authName||item.fctm02}.png`"
              alt=""
              width="18"
              @error="defImg($event)"
              style="margin-right: 5px;"
            />
            <span :target-id="item.authName">{{
              item.authName || item.fctm02
            }}</span>
          </template>
          <div v-for="tag in item.children" :key="tag.id">
            <el-submenu
              :index="tag.fctm01 || tag.path"
              v-if="tag.children && tag.children.length > 0"
            >
              <template slot="title">
                <!-- <i class="el-icon-star-off"></i> -->
                <img
                  src=""
                  alt=""
                  style="margin-right: 5px;"
                />
                {{ tag.authName || tag.fctm02 }}</template
              >
              <el-menu-item
                :key="c.id"
                :target-id="c.path"
                :index="c.fctm01 || c.path"
                v-for="c in tag.children"
                @click="
                  $router.replace({
                    path: '/' + c.path,
                  })
                "
              >
                &nbsp;&nbsp;
                <!-- <i class="el-icon-tickets"></i> -->
                <img
                  src=""
                  alt=""
                  style="margin-right: 5px;"
                />
                {{ c.authName || c.fctm02 }}</el-menu-item
              >
            </el-submenu>
            <el-menu-item
              :index="tag.fctm01 || tag.pName || tag.path"
              @click="
                refreshData &&
                  $router.replace({
                    path: '/' + tag.path,
                    query: tag.pName
                      ? {
                          key: $UrlEncode.encode(
                            JSON.stringify({ type: tag.pid, name: tag.pName })
                          ),
                        }
                      : {},
                  })
              "
              v-else
            >
              <span style="text-align: center" slot="title">
                <!-- <i class="el-icon-star-off"></i> -->
                <img
                  src=""
                  alt=""
                  style="margin-right: 5px;"
                />
                {{ tag.authName || tag.fctm02 }}</span
              >
            </el-menu-item>
          </div>
        </el-submenu>
      </el-menu>
      <el-main>
        <router-view v-if="viewShow" ref="view"></router-view>
      </el-main>
    </el-container>
  </div>
</template>
 
<script>
import { GetProjectInfo, GetRoleList, GetFunctionTemplate } from "@/setAxios";
export default {
  data() {
    return {
      viewShow: true,
      paths: "ProjectInformation",
      isCollapse: true,
      menuData: [
        {
          id: 1,
          authName: "项目概览",
          path: "ProjectSettings",
          icon: "el-icon-s-platform",
          targetid: "ProjectSettings",
          children: [
            { id: 101, authName: "项目信息", path: "ProjectInformation" },
            { id: 102, authName: "通知管理", path: "InformManagement" },
            { id: 103, authName: "作业面维护", path: "JobPage" },
            {
              id: 2,
              authName: "团队配置",
              path: "Moreservice",
              icon: "el-icon-user-solid",
              children: [
                { id: 201, authName: "成员管理", path: "userManagement" },
                { id: 202, authName: "岗位权限", path: "PostPermissions" },
                { id: 203, authName: "动态标签", path: "weiboLabel" },
              ],
            },
            {
              id: 3,
              authName: "协作设置",
              path: "notice",
              icon: "el-icon-s-flag",
              children: [
                { id: 301, authName: "工单设置", path: "singleSet" },
                { id: 302, authName: "话题标签设置", path: "topic" },
              ],
            },
            {
              id: 7,
              authName: "资料管理设置",
              icon: "el-icon-s-order",
              path: "DataSetting",
              children: [
                { id: 701, authName: "资料目录配置", path: "dataDirectory" },
                { id: 702, authName: "图纸目录配置", path: "Drawings" },
                {
                  id: 703,
                  authName: "预定义审核流程",
                  path: "predefinedAuditProcess",
                },
              ],
            },
            {
              id: 13,
              authName: "条码管理设置",
              icon: "el-icon-s-grid",
              path: "barCode",
              children: [{ id: 1301, authName: "模板设置", path: "template" }],
            },
            {
              id: 14,
              icon: "el-icon-s-opportunity",
              authName: "实景管理设置",
              path: "live",
              children: [
                { id: 1401, authName: "标签配置", path: "tagSetting" },
              ],
            },
          ],
        },
 
        // {
        //   id: 4,
        //   path: "dept1",
        //   authName: "流程表单配置",
        //   icon: "el-icon-menu",
        //   children: [
        //     { id: 401, authName: "表单模版", path: "formTemplate" },
        //     { id: 402, authName: "审核流程", path: "chartFlow" },
        //   ],
        // },
        // {
        //   id: 4,
        //   path: "dept1",
        //   authName: "综合管理设置",
        //   icon: "el-icon-menu",
        //   children: [
        //     { id: 401, authName: "设计协调配置", path: "coordinate" },
        //     { id: 402, authName: "工程联系单配置", path: "ContactList" },
        //   ],
        // },
        // {
        //   id: 5,
        //   path: "dept2",
        //   authName: "安全管理设置",
        //   icon: "el-icon-menu",
        //   children: [{ id: 501, authName: "安全交底配置", path: "security" }],
        // },
        // {
        //   id: 6,
        //   path: "dept3",
        //   authName: "质量管理设置",
        //   icon: "el-icon-menu",
        //   children: [
        //     { id: 602, authName: "施工交底配置", path: "construction" },
        //   ],
        // },
      ],
    };
  },
  // 利用计算属性
  computed: {
    xidNameupdata() {
      return this.$store.state.xidName;
    },
    roleNameUpdata() {
      return this.$store.state.roleName;
    },
  },
  //监听执行
  watch: {
    xidNameupdata() {
      this.$router.push({
        name: "userProjectIndex",
      });
      window.location.reload();
      this.GetFunctionTemplate();
    },
    roleNameUpdata() {
      this.$router.push({
        name: "userProjectIndex",
      });
      window.location.reload();
    },
  },
  methods: {
    defImg(event) {
      let img = event.srcElement;
      img.src = "./img/6.0/PC/风险管理.png";
      img.onerror = null; //防止闪图
    },
    handleOpen() {},
    handleClose() {},
    GetFunctionTemplate() {
      let that = this;
      GetFunctionTemplate({
        params: { companyId: localStorage.pid, xid: localStorage.xid },
      }).then((res) => {
        let list = that
          .getTreeDate(res.Data.projectfunctiontemplates, "fctm01", "fctm03")
          .map((item) => {
            item.children = [
              {
                id: "A" + item.fctm01,
                pid: item.fctm01,
                authName: "流程配置",
                pName: item.fctm02 + "流程配置",
                path: "flowLayout",
              },
              {
                id: "B" + item.fctm01,
                pid: item.fctm01,
                authName: "模版配置",
                pName: item.fctm02 + "模版配置",
                path: "modelConfigure",
              },
              {
                id: "C" + item.fctm01,
                pid: item.fctm01,
                authName: "数据查询",
                pName: item.fctm02 + "数据查询",
                path: "dataQuery",
              },
            ];
            return item;
          });
        that.menuData = that.menuData.concat(list);
      });
    },
    getTreeDate(data, idName, pidName) {
      let result = [];
      if (!Array.isArray(data)) {
        return result;
      }
      data.forEach((item) => {
        delete item.children;
      });
      let map = {};
      data.forEach((item) => {
        item["path"] = "ProjectMenuTemplate";
        map[item[idName]] = item;
      });
 
      data.forEach((item) => {
        let parent = map[item[pidName]];
        if (parent) {
          // item.parent=parent
          (parent.children || (parent.children = [])).push(item);
        } else {
          (item["icon"] = "el-icon-star-on"), result.push(item);
        }
      });
      return result;
    },
    // 点击项目进行跳转
    pushProject(item) {
      this.$store.state.xidName = item.proj07;
      localStorage.setItem("xid", item.proj01);
      this.$store.state.xid = item.proj01;
      localStorage.setItem("XmName", item.proj07);
      localStorage.setItem("XmBh", item.proj02);
      let params = {
        qid: localStorage.pid,
        xid: localStorage.xid,
        uid: localStorage.id,
      };
      GetRoleList(params).then((res) => {
        if (res.Data.length == 0) {
          this.$message({
            type: "warning",
            message: "当前用户在此项目中未设置角色，请联系管理员！",
          });
          return false;
        }
        this.$store.state.isClickProject = true;
        this.$store.state.jobs = res.Data;
        this.$store.state.roleName = res.Data[0].roleName;
        if (res.Data[0].isPM) {
          this.$store.state.isProject = true;
        } else {
          this.$store.state.isProject = false;
        }
        this.$store.state.permissions =
          res.Data[0].roleRight == null
            ? null
            : res.Data[0].roleRight.split(",");
      });
    },
    out() {
      outLogin().then((res) => {
        localStorage.removeItem("token");
        this.$message({
          type: "success",
          message: "退出成功",
        });
        this.$router.push({
          path: "/login",
        });
      });
    },
    // 执行刷新
    refreshData() {
      // this.$refs.view.getData();
      this.viewShow = false;
      this.$nextTick(() => {
        this.viewShow = true;
      });
    },
  },
  created() {
    if (!this.$store.state.isClickProject) {
      this.$store.state.btnStyle[0] = "btns";
      this.$store.state.btnStyle[1] = "btns";
      this.$store.state.btnStyle[2] = "btnss";
      this.$store.state.btnStyle[3] = "btns";
      let params = {
        id: localStorage.xid,
      };
      GetProjectInfo({ params }).then((res) => {
        let item = res.Data;
        this.pushProject(item);
      });
    }
 
    if (this.$route.query && this.$route.query.hasOwnProperty("key")) {
      this.paths = JSON.parse(
        this.$UrlEncode.decode(this.$route.query.key)
      ).name;
    } else {
      this.paths = this.$route.fullPath.substr(1);
    }
 
    this.GetFunctionTemplate();
  },
  mounted() {},
};
</script>
 
<style lang="less" scoped>
.flexLR {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.control {
  width: 100%;
  height: 100%;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}
.el-container {
  display: -webkit-box;
  width: 100%;
  height: 100%;
}
.el-menu-item i {
  color: #fff;
}
/deep/.el-submenu__title i {
  color: #fff;
}
.el-menu-vertical-demo {
  height: 100%;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  overflow-x: hidden;
  // width: 22%;
  height: 100%;
}
/* 新增 */
.bg-cor {
  background-color: rgba(0, 0, 0, 0);
  overflow: hidden;
}
.height100 {
  height: 100%;
}
.mar-r36p {
  margin-right: 36px;
}
.font-sz18 {
  font-size: 18px;
  font-weight: 600;
}
</style>